<form [formGroup]="form">

  <div class="form-row">
    <label for="txtCode">{{ "APPLICATIONS.CODE" | translate | requiredLabel }}</label>
    <input type="text" id="txtCode" class="w-full" pInputText formControlName="code" />
  </div>

  <div class="form-row">
    <label for="txtDescription">{{ "APPLICATIONS.DESCRIPTION" | translate | requiredLabel }}</label>
    <input type="text" id="txtDescription" class="w-full" pInputText formControlName="description" />
  </div>

</form>

<div class="p-dialog-footer">

  <p-button label="Guardar cambios" (click)="saveChanges()" [loading]="saving"></p-button>

</div>
